import { render, staticRenderFns } from "./pendingJapanReview.vue?vue&type=template&id=6331f6bd&scoped=true&"
import script from "./pendingJapanReview.vue?vue&type=script&lang=js&"
export * from "./pendingJapanReview.vue?vue&type=script&lang=js&"
import style0 from "./pendingJapanReview.vue?vue&type=style&index=0&id=6331f6bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6331f6bd",
  null
  
)

export default component.exports